interface RegistrationActionsProps {
  onCleanup: () => void;
  cleanupLoading: boolean;
}

export function RegistrationActions({
  onCleanup,
  cleanupLoading,
}: RegistrationActionsProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-medium text-gray-900">Registration Management</h3>
          <p className="text-sm text-gray-600 mt-1">
            Remove all expired registrations from the database.
          </p>
        </div>
        <button
          onClick={onCleanup}
          disabled={cleanupLoading}
          className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center"
        >
          {cleanupLoading ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Cleaning...
            </>
          ) : (
            <>
              <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Cleanup Expired
            </>
          )}
        </button>
      </div>
    </div>
  );
}
